import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const InputText = ({
    onChange,
    value,
    type,
    name,
    placeholder,
    additionalClass,
    additionalInputClass,
    label,
    error,
    hasError = true,
    variant = 'white',
    helperText,
    isRequired,
    hintText,
    isCellLocation = false,
    showExtraInfo = true,
    icon,
    ...otherProps
}) => {
    const isTextArea = type === 'textarea'

    const defaultClassName = variant === 'white' ? 'inputWhite' : 'inputBlack'
    const displayClassName = clsx(
        defaultClassName,
        additionalInputClass,
        isTextArea && 'min-h-20 resize-none',
    )

    return (
        <div
            className={clsx(
                'w-full flex flex-col items-start justify-start',
                additionalClass,
            )}
        >
            {label && (
                <div className="w-full h-auto flex items-center justify-between mb-2">
                    <label
                        htmlFor={name}
                        className={clsx(
                            'w-auto h-auto text-sm font-medium text-left',
                            variant === 'white'
                                ? 'text-textDarkerGray'
                                : 'text-white',
                        )}
                    >
                        {label}
                        {isRequired && (
                            <span className="text-error ml-1">*</span>
                        )}
                    </label>
                    {helperText && helperText}
                </div>
            )}

            {isCellLocation ? (
                <>{value}</>
            ) : isTextArea ? (
                <>
                    <textarea
                        {...otherProps}
                        value={value}
                        onChange={onChange}
                        name={name}
                        placeholder={placeholder}
                        id={name}
                        className={displayClassName}
                        aria-label={`TextArea ${name}`}
                    />
                    {icon && icon}
                </>
            ) : (
                <>
                    <input
                        {...otherProps}
                        type={type || 'text'}
                        value={value}
                        onChange={onChange}
                        name={name}
                        placeholder={placeholder}
                        id={name}
                        className={displayClassName}
                        aria-label={`Input Text ${name}`}
                    />
                    {icon && icon}
                </>
            )}
            {showExtraInfo && (
                <div className="w-full h-auto flex flex-row items-center justify-between">
                    {hintText && (
                        <p
                            className={clsx(
                                hintText ? 'visible' : 'invisible',
                                'flex-grow h-4 text-left text-textDarkGray font-medium text-xs mt-2',
                            )}
                        >
                            {hintText}
                        </p>
                    )}
                    {hasError && (
                        <p
                            className={clsx(
                                error ? 'visible' : 'invisible',
                                'flex-grow h-4 text-error font-medium text-xs mt-1 text-right',
                            )}
                        >
                            {error}
                        </p>
                    )}
                </div>
            )}
        </div>
    )
}

InputText.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
    name: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    additionalClass: PropTypes.string,
    label: PropTypes.string,
    additionalInputClass: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    hasError: PropTypes.bool,
    variant: PropTypes.string,
    helperText: PropTypes.element,
    isRequired: PropTypes.bool,
    hintText: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
    isCellLocation: PropTypes.bool,
    showExtraInfo: PropTypes.bool,
    icon: PropTypes.node,
}

export default InputText
